import { LoginResponse } from "@/services/datatypes/api";
import { User } from "@/services/datatypes/auth";
import { useGetSubscriptions } from "./useGetSubscriptions";

export const useGetLoginData = () => {
    const { getSubscriptions } = useGetSubscriptions();

    const getLoginData = async (loginResponse: LoginResponse): Promise<User> => {
        if (!loginResponse || !loginResponse.uid || !loginResponse.username) {
            throw new Error('Invalid login response');
        }
        const response = await getSubscriptions(loginResponse.token);
        //console.log("getLoginData - response:", response);

        const user: User = {
            id: loginResponse.uid,
            name: loginResponse.username,
            permissions: ['user'],
            subscriptions: response.entries,
        };
        return user;
    }
    return { getLoginData }
}